import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';
import { useSmartLinkContext } from '@atlaskit/link-provider';
import { fg } from '@atlaskit/platform-feature-flags';
var PENDING_STATE = {
  status: 'pending'
};
export function useSmartCardState(url, placeholderData) {
  var _useSmartLinkContext = useSmartLinkContext(),
    store = _useSmartLinkContext.store;
  var cardState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState, function (state) {
    return state[url];
  });
  if (fg('platform_initial_data_for_smart_cards')) {
    return (cardState === null || cardState === void 0 ? void 0 : cardState.status) !== 'resolved' && placeholderData ? placeholderData : cardState !== null && cardState !== void 0 ? cardState : PENDING_STATE;
  }
  return cardState !== null && cardState !== void 0 ? cardState : PENDING_STATE;
}